import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Popup from '../../components/ConformationPopup/Popup';
import { OnlyNumberSpecialChar } from '../../utils/RegHandling';
import {
    deleteMoodCategoryData,
    getMoodCategoryData,
    postMoodCategoryData,
    updateMoodCategoryData,
    updateTeamMoodData,
} from '../../service/adminApi';
import Loader from '../../StaticComponent/Loader';
import './teammembermood.css';

function TeamMoodCategory() {
    let breadCrumbsData = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Team Member Mood', isActive: true, path: '' },
        { title: 'Category', isActive: false, path: '' },
    ];

    const [moodCategoryList, setMoodCategoryList] = React.useState([]);
    const [moodCategory, setMoodCategory] = React.useState('');
    const [showCategory, setShowCategory] = React.useState(false);
    const [nameError, setNameError] = React.useState('');
    const [editId, setEditId] = React.useState('');
    const [flag, setFlag] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState();
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        getMoodCategory();
    }, []);

    const getMoodCategory = async () => {
        const response = await getMoodCategoryData();
        setMoodCategoryList(response.data.data);
        setLoading(true);
    };

    const deleteCategory = async () => {
        let data = {
            id: moodCategoryList[deleteIndex].id,
            is_active: false,
        };
        const response = await deleteMoodCategoryData(data);
        if (response.data.statusCode === 200) {
            let array = moodCategoryList;
            let arr = array.splice(deleteIndex, 1);
            let updatedData = array;
            setMoodCategoryList(updatedData);
            setFlag(!flag);
        }
    };

    const addCategory = async () => {
        if (moodCategory !== undefined && moodCategory !== '' && moodCategory.length > 3 && OnlyNumberSpecialChar(moodCategory) == false) {
            if (editId === undefined || editId === '') {
                const response = await postMoodCategoryData({
                    name: moodCategory,
                });
                if (response.data.statusCode === 200) {
                    // let data = [...moodCategoryList, { name: moodCategory, id: response.data.data[0].id }];

                    getMoodCategory();
                    // setMoodCategoryList(data);
                    setMoodCategory('');
                    setShowCategory(false);
                    setEditId('');
                }
            } else {
                let data = {
                    name: moodCategory,
                    id: editId,
                };
                const response = await updateMoodCategoryData(data);
                if (response.data.statusCode === 200) {
                    getMoodCategory();
                    setMoodCategory('');
                    setEditId('');
                    setShowCategory(false);
                }
            }
        } else {
            setNameError('Please  provide a valid name');
        }
    };

    const renderMoodCategoryList = () => {
        return moodCategoryList.map((category, index) => {
            return (
                <div className="holidaylist-row-table mt-3 holidaylist-bg">
                    <table className="table-style w-100 font-12">
                        <tbody>
                            <tr className="td-style">
                                <td className="td-style font-12 medium-text category-card-spacing">{category.name}</td>
                                <td className="border-left">
                                    <a
                                        onClick={() => {
                                            setShowCategory(true);
                                            setEditId(category.id);
                                            setMoodCategory(category.name);
                                        }}
                                        className="hive-table-sort ms-4"
                                        alt=""
                                    >
                                        <img src="/Images/edit1.svg" className="" alt="bin" />
                                    </a>
                                    <a
                                        onClick={() => {
                                            setDeleteIndex(index);
                                        }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#logout"
                                        className="ms-5 hive-table-sort"
                                        alt=""
                                    >
                                        <img src="/Images/bin.svg" className="" alt="close" />
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        });
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            <div className="admin-panel-bg p-3">
                <div className="row">
                    <div className="col-md-6 mb-5">
                        <h5 className="bold-text tt-bold font-18">Team Members Mood - Category</h5>
                        <p className="font-13 regular-text font-grey mb-5">
                            Team members' mood helps to know the mood of the employees based on the category
                        </p>

                        <div class="row justify-content-between mb-2 d-flex align-items-center">
                            <div class="col-md-4">
                                <h1 className="font-14 mt-2 bold-text">Category</h1>
                            </div>
                            <div class="col-md-4 text-end">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowCategory(true);
                                    }}
                                    class="btn hive-btn-outline font-12 bold-text"
                                >
                                    Add Category
                                </button>
                            </div>
                        </div>

                        {showCategory ? (
                            <div className="holidaylist-row-table mt-3">
                                <table className="table-style w-100 font-12">
                                    <thead>
                                        <tr className="th-style font-medium-blue">
                                            <th className="py-2 ps-0 ">Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="td-style">
                                            <td
                                                className="td-style category-card-spacing font-12 ps-0 medium-text"
                                                style={{
                                                    paddingRight: '13rem',
                                                }}
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Category"
                                                    value={moodCategory}
                                                    className="form-control holidaylist-bg custom-textfield font-12 custom-input-background font-medium-blue"
                                                    onChange={(e) => {
                                                        setMoodCategory(e.target.value);
                                                        setNameError('');
                                                    }}
                                                />
                                                <span className="text-danger tt-bold font-12">{nameError}</span>
                                            </td>
                                            <td className="holidaylist-border-left ps-3">
                                                <a
                                                    onClick={() => {
                                                        addCategory();
                                                    }}
                                                    className="hive-table-sort"
                                                    alt=""
                                                >
                                                    <img src="/Images/tick.svg" className="" alt="tick" />
                                                </a>
                                                <a
                                                    onClick={() => {
                                                        setShowCategory(false);
                                                        setMoodCategory('');
                                                        setNameError('');
                                                        setEditId('');
                                                    }}
                                                    className="ps-4 hive-table-sort"
                                                    alt=""
                                                >
                                                    <img src="/Images/close.svg" className="" alt="close" />
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ) : null}

                        {renderMoodCategoryList()}
                    </div>
                </div>
            </div>
            <Popup
                deleteData={() => {
                    deleteCategory();
                }}
            />
            <Loader isLoading={loading} />
        </div>
    );
}

export default TeamMoodCategory;
